import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.82942 6.375L10.0794 3H1.875V6.375H7.82942Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1706 3L13.9206 6.375H22.125V3H16.1706Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.875 7.5H22.125V21H1.875V7.5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9249 14.0573C15.0749 14.144 15.0749 14.3605 14.9249 14.4471L10.5374 16.9802C10.3874 17.0668 10.1999 16.9585 10.1999 16.7853L10.1999 11.7191C10.1999 11.5459 10.3874 11.4376 10.5374 11.5242L14.9249 14.0573Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.3294 6.375L14.5794 3H11.6704L9.42041 6.375H12.3294Z",
			fill: "black"
		})
	]
});
export default SvgIconVideo;
